

















import {Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { UserProfile } from '@api/models/UserProfile';
import UsersListItem from "@share/common/users-list/UsersListItem.vue"

@Component({ components: { UsersListItem } })
export default class UserSelectListBox extends Vue {

    @Prop({ default: () => [] }) profiles: UserProfile[];
}

